export default {
  none: 'none',
  top: 'top',
  bottom: 'bottom',
  right: 'right',
  left: 'left',
}
